import React, { useEffect, useState } from "react"
import { ReactComponent as Scanner } from "assets/img/svg/scanner.svg"
import AInput from "views/pages/manage/common/formFeilds/customInput/AInput"
import AAutoComplete from "views/pages/manage/common/form-fields-mui/AAutoComplete"
import { Modal } from "@mui/material"
import { Col, Container, Label, Row } from "reactstrap"
import AButton from "views/pages/manage/common/form-fields-mui/AButton"
import Error from '../../errorHandlimg/Error'
import { getAllCardType } from '../../dropdowns'
import { useGetCollectPaymentContext } from "../../../context"
import { customStyle, inputAmountStyle, labelSyle, numberDecimalLimitRegex, 
    // validatePaymentMode 
} from "../../components/constant"
import { cardValidation } from "../../validations/paymentModeValidation"
import { getConditionalCOllectSaveButton } from "../../components/common"

const Card=({heading,dialogCloseHandler, isEditForm,isReceiptEdit=false, isView=false,contextValue,rowId,handleClose})=>{
    
    const [errorMgs,setErrorMgs] =useState('')
    const [cardTypeDropdown,setCardTypeDropdown]= useState([{}])
    
      const {
        setModifyPaymentModeData,
        bankDropdown,
        paymentModeFormHandler,
        studentBasicDetails, 
        currentPaymentMode,
        paymentModeForm,
        selectedChargesAmount,
        bankMasterId,
        setBalanceAmount,
        setBalanceMode,
        setloader,
        setCollectPayment,
        collectPayment,
        balanceAmount,
        validatePaymentMode,
        disableAmountField
    } = contextValue;
      const validatePayment = async () => {  
        const error = await cardValidation(paymentModeForm,balanceAmount)
        setErrorMgs(error)
        if(!error)
            {
               const isOk= await validatePaymentMode(studentBasicDetails,currentPaymentMode,paymentModeForm,selectedChargesAmount,bankMasterId,'',setBalanceAmount,setBalanceMode,setloader,setCollectPayment,balanceAmount,collectPayment)

               if(isOk){
                isReceiptEdit===true&&setModifyPaymentModeData((prev) => ({ ...prev, [rowId]: paymentModeForm }))
                isReceiptEdit&& handleClose(true)
               }
    
            }  
}

      useEffect(()=>{
        const getDropdown = async () => {
            const dropdown = await getAllCardType();
            setCardTypeDropdown(dropdown);
        }
       !isView && getDropdown();
    
      },[])

      const disabled=!(paymentModeForm?.paidAmount&&paymentModeForm?.referenceNumber&&paymentModeForm?.cardType&&paymentModeForm?.bank)

    return(
            <>
             {!isView&&!isReceiptEdit&&<div className=" d-flex justify-content-between align-items-center mt-2">
                <span className="large-bold color-dark">{heading}</span>
            </div>
            }
            <Row>
                <Col md="4">
                    <div>
                        <AInput
                            label="Enter amount"
                            labelStyle={labelSyle}
                            value={paymentModeForm?.paidAmount}
                            handler={(value) => {
                                if (
                                    !value || parseFloat(value) > 0
                                ) {
                                    paymentModeFormHandler('paidAmount',value)
                                }
        
                            }}
                            placeholder="Enter amount"
                            customIcon={
                                <div className='large-semi-bold'>&#8377;</div>
                              }
                              customIconStyle={customStyle}
                            style={inputAmountStyle}
                            disabled={isView||isReceiptEdit===true || disableAmountField}
                            regex={numberDecimalLimitRegex(8, 2)}
                        />
                    </div>
                </Col>
                <Col md="4">
                    <div>
                    <AAutoComplete
                            label="Card Type"
                            labelStyle={labelSyle}
                            placeholder="Select card type"
                            currentValue={paymentModeForm?.cardType}
                            handleChange={(value) => {paymentModeFormHandler("cardType",value)}}
                            items={cardTypeDropdown}
                            isMulti={false}
                            isShowCount={false}
                            style={{ control: { height: "47px", width: '265px', borderRadius: "5px" } }}
                            isInputChange={true}
                            isDisabled={isView}
                        />
                    </div>
                </Col>
                <Col md="4">
                    <div>
                        <AAutoComplete
                            label="Bank"
                            labelStyle={labelSyle}
                            placeholder="Select bank"
                            currentValue={paymentModeForm?.bank}
                            handleChange={(value) => {paymentModeFormHandler("bank",value) }}
                            items={bankDropdown}
                            isMulti={false}
                            isShowCount={false}
                            style={{ control: { height: "47px", width: '265px', borderRadius: "5px" } }}
                            isInputChange={true}
                            isDisabled={isView}
                        />
                    </div>
                </Col>
            </Row>
            <Row>
                <Col md="4">
                <div>
                        <AInput
                            label="Enter last 4 digit"
                            labelStyle={labelSyle}
                            value={paymentModeForm?.referenceNumber}
                            handler={(value) => {paymentModeFormHandler("referenceNumber",value) }}
                            onKeyPress={(e) => {
                                if (
                                    !/^[0-9]*$/.test(
                                        String.fromCharCode(e.charCode)
                                    )
                                ) {
                                    e.preventDefault();
                                    return;
                                }
                            }}
                            maxLength={4}
                            placeholder="xxxx-xxxx-xxxx - 4 digit"
                            style={{ height: "47px", width: '265px', borderRadius: "5px" }}
                            disabled={isView}
                        />
                    </div>
                    
                </Col>
                <Col md="4">
                <div>
                        <AInput
                            label="First Name"
                            labelStyle={labelSyle}
                            value={paymentModeForm?.firstName}
                            handler={(value) => {paymentModeFormHandler("firstName",value) }}
                            placeholder="Enter first name"
                            style={{ height: "47px", width: '265px', borderRadius: "5px" }}
                            disabled={isView}
                            onKeyPress={(e) => {
                                if (
                                    !/^[a-zA-Z]*$/.test(
                                        String.fromCharCode(e.charCode)
                                    )
                                ) {
                                    e.preventDefault();
                                    return;
                                }
                            }}
                            
                        />
                    </div>
                </Col>
                <Col md="4">
                <div>
                        <AInput
                            label="Last Name"
                            labelStyle={labelSyle}
                            value={paymentModeForm?.lastName}
                            handler={(value) => {paymentModeFormHandler("lastName",value) }}
                            placeholder="Enter last name"
                            style={{ height: "47px", width: '265px', borderRadius: "5px" }}
                            onKeyPress={(e) => {
                                if (
                                    !/^[a-zA-Z]*$/.test(
                                        String.fromCharCode(e.charCode)
                                    )
                                ) {
                                    e.preventDefault();
                                    return;
                                }
                            }}
                            
                            disabled={isView}
                        />
                    </div>
                </Col>
            </Row>
            {getConditionalCOllectSaveButton(disabled,
                paymentModeForm,
                validatePayment,
                isReceiptEdit,
                isEditForm,
                isView,
                setModifyPaymentModeData,
                rowId,
                handleClose)}
            <Error errorMgs={errorMgs}/>
            </>
    )
}
export default Card